import gql from 'graphql-tag';

export const DELETE_CONDITION = gql`
  mutation deleteCondition($questionConditionId: Int!) {
    questionAction {
      removeCondition(conditionId: $questionConditionId)
    }
  }
`;
